import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Prompt } from 'react-router'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next/hooks';
import openSocket from 'socket.io-client';
import Linkify from 'react-linkify';
import Img from "react-cool-img";

// import WebStream from './WebStream';

import AutoSuggestVideoTextTalk from '../../components/AutoSuggest/AutoSuggestVideoTextTalk';
import Button from '../../components/Button/Button';
import Input from '../../components/Form/Input/Input';
import InputEmoji from '../../components/Form/Input/InputEmoji';
// import UserTalkList from './UserTalkList';

import CreateGroupForm from '../../components/GroupTalk/EditGroup/CreateGroupForm';
import EditGroupForm from '../../components/GroupTalk/EditGroup/EditGroupForm';

// import GroupAdElements from '../../components/GroupTalk/GroupAdElements/GroupAdElements';
import AdElementDisplay from '../../components/GroupTalk/GroupAdElements/AdElememtDisplay/AdElementDisplay';

import GroupList from '../../components/GroupTalk/GroupList/GroupList';
import GroupListControll from '../../components/GroupTalk/GroupList/GroupListControll';
import GroupInfoMemberList from '../../components/GroupTalk/GroupInfo/GroupInfoMemberList';
import GroupJoinControll from '../../components/GroupTalk/GroupInfo/GroupJoinControll';
import GroupTalkTextInput from '../../components/GroupTalk/GroupTextList/GroupTalkTextInput';
import GroupTalkTextListInfo from '../../components/GroupTalk/GroupInfo/GroupTalkTextListInfo';
import GroupTalkTextList from '../../components/GroupTalk/GroupTextList/GroupTalkTextList';
import GroupTalkAuthModal from './GroupTalkAuthModal';
import GroupTopElements from '../../components/GroupTalk/GroupAdElements/GroupTopElements/GroupTopElements';
import GroupRightElements from '../../components/GroupTalk/GroupAdElements/GroupRightElements/GroupRightElements';
import GroupTalkSocket from './GroupTalkSocket';
import GroupUserUpdate from './GroupUserUpdate';
import Loader from '../../components/Loader/Loader';

import GroupTalkText from './GroupTalkText';
import GroupTalkControl from './GroupTalkControl';

import { 
  getUserData, 
  getUserDataForStore, 
  getUsers, 
  getUsersRest, 
  getUsersForGroup, 
  getUserLocation, 
  updateUserColor 
} from '../../util/user';
import { getLocalTimeElements } from '../../util/timeFormat';
import { getRandomBgColor } from '../../util/color-style';
import { 
  getGroupRoomInUsersHandler, 
} from "../../util/group/group-socket-handlers";

import {
  sendTextPushHandler,
  sendGroupTextPushHandler
} from '../../util/pushNotification';
import { 
  storeDraftInput, 
  getDraftInput, 
  deleteDraftInput 
} from '../../util/style';
import { updateLsNameDataList } from '../../util/user-name-data/user-name-data-util';

import { useStore } from '../../hook-store/store';

import { 
  GQL_URL, 
  BASE_URL, 
  SOCKET_URL, 
  SOCKET_SURL, 
  SOCKET_GROUP_SURL, 
  PUSH_URL, 
  SOCKET_GROUP_URL 
} from '../../App';

import '../VideoTextTalk/VideoTextTalk.css'
import './GroupTalk.css';

// import SampleImage from '../../components/Image/person-icon-50.jpg';

// import * as firebase from "firebase/app";
// // Add the Firebase services that you want to use
// import "firebase/auth";
// import "firebase/firestore";
// import { isNull, join } from 'lodash';


let isAlreadyCalling = false;
let getCalled = false;

const existingCalls = [];

const { RTCPeerConnection, RTCSessionDescription } = window;
const peerConnection = new RTCPeerConnection();



const GroupTalk = (props) => {
  // console.log('GroupTalk.js-props', props);
  // const videoRef = React.createRef();
  const currentUrl = new URL(window.location.href);
  const queryParams = currentUrl.searchParams;
  const roomIdParam = queryParams.get('groupRoomId');
  // console.log('query grouproomid', roomIdParam);



  const lsToken = localStorage.getItem('token');

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    // joinedGroupData,
    selectedGroupData,
    userSocketId,
    socketState,
    groupList,
    isGroupMember,
    groupNoAuthUserId,
    groupRoomInUsersData,
    groupTextInput,
  } = store.groupStore;
  const {
    isAuth
  } = store.uiStore;
  const { 
    userData, 
  } = store;

  const userId = userData?.userId ? userData.userId : groupNoAuthUserId;
  const userName = '';
  // console.log('joinedGroupData in GroupTalk.js', joinedGroupData);

  const [userSocket, setUserSocket] = useState('');
  // const [userSocketId, setUserSocketId] = useState('');
  const [userList, setUserList] = useState([]);
  // const [socketState, setSocketState] = useState('');
  const [callFrom, setCallFrom] = useState('');
  const [callingTo, setCallingTo] = useState('');
  const [isCalling, setIsCalling] = useState(false);
  const [textInput, setTextInput] = useState('');
  const [textInputList, setTextInputList] = useState([]);
  const [userImageUrl, setUserImageUrl] = useState('');
  const [userListObj, setUserListObj] = useState([]);
  const [showTextTalk, setShowTextTalk] = useState(false);
  const [isTextTalkDiv, setIsTextTalkDiv] = useState(false);
  const [tryingToCallUser, setTryingToCallUser] = useState('');
  const [talkStartAt, setTalkStartAt] = useState('');
  const [callReject, setCallReject] = useState(false);
  const [noUserMessage, setNoUserMessage] = useState('');
  const [userTextTalkList, setUserTextTalkList] = useState([]);
  const [showUserTextTalkList, setShowUserTextTalkList] = useState(true);
  const [showNoconnectTextTalk, setShowNoconnectTextTalk] = useState(false);
  const [noconnectDestUserId, setNoconnectDestUserId] = useState('');
  const [callGet, setCallGet] = useState(false);
  const [suggestList, setSuggestList] = useState([]);
  const [noconnectMessageNotify, setNoconnectMessageNotify] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [showGroupCreation, setShowGroupCreation] = useState(false);
  const [createGroupReslut, setCreateGroupReslut] = useState('');
  const [isCreateGroup, setIsCreateGroup] = useState(false);
  const [showGroupTalkText, setShowGroupTalkText] = useState(false);
  const [deleteMemberResult, setDeleteMemberResult] = useState('');
  const [selectedGroupForEdit, setSelectedGroupForEdit] = useState();
  const [deleteGroupResult, setDeleteGroupResult] = useState('');

  // const [groupTextInput, setGroupTextInput] = useState('');
  const [groupTalkInputList, setGroupTalkInputList] = useState([]);
  const [groupTalkId, setGroupTalkId] = useState('');
  const [groupInfo, setGroupInfo] = useState('');
  // const [groupAllMemberList, setGroupAllMemberList] = useState([]);

  const [showGroupTextInputElement, setShowGroupTextInputElement] = useState(true);
  const [isTextPosting, setIsTextPosting] = useState(false);

  const [showAuthModal, setShowAuthModal] = useState(false);

  const [groupUserInfo, setGroupUserInfo] = useState();
  const [editFavoriteGroupsResult, setEditFavoriteGroupsResult] = useState('');
  
  const [groupTextReactions, setGroupTextReactions] = useState([]);
  
  useEffect(() => {
    document.title = 'Group page'
  },[]);


  useEffect(() => {
    // socketConnectHandler();
    window.scrollTo(0, 0);
    console.log(new Date().toUTCString());

    return () => {
      console.log('cleanup socketTest');
      // socketState.disconnect();
      // resetSocket();
      window.location.reload();
    }
  }, []);

  // useEffect(() => {
  //   if (userId && !userId.startsWith('na-')) {
  //     getUserLocation()
  //       .then(res => {
  //         console.log(res);
  //       })
  //       .catch(err => {
  //         console.log(err);
  //       });
  //   }
  // },[userId]);

  // useEffect(() => {

  //   if (!userId) {
  //     if (!store.userData) {
  //       // getUserData(GQL_URL, localStorage.getItem('token'))
  //       getUserDataForStore(BASE_URL, localStorage.getItem('token'))
  //       .then(result => {
  //         console.log(result);

  //         dispatch('SET_USERDATA', result.userData);

  //         // setUserName(result.userData.name);
  
  //         // setUserId(result.userData.data.user._id);
  //         // setUserId(result.userData.userId);
  
  //         if (result.userData.imageUrl) {
  //           setUserImageUrl(result.userData.imageUrl);
  //         }

  //         if (!result.userData.userColor) {
  //           updateUserColor(
  //             BASE_URL,
  //             localStorage.getItem('token'),
  //             result.userData.userId,
  //             getRandomBgColor(),
  //           );
  //         }
  //         // socketConnectHandler();
  //       })
  //       .catch(err => {
  //         console.log('getUserDataForStore err', err);
  //         // setNoUserMessage('need to login');
  //         setNoUserMessage('');

  //         //// if user data not found (not login), set non-auth userId and name
  //         const noAuthUserId = `na-${Math.floor(Date.now()/100).toString()}`;
  //         // setUserId(noAuthUserId);
  //         dispatch('SET_GROUPNOAUTHUSERID', noAuthUserId);

  //         // setUserName('na');
  //       });
  //     }

  //     if (isAuth && userData) {
  //       // setUserName(store.userData.name);
  //       // setUserId(store.userData._id);
  //       // setUserId(store.userData.userId);

  //       if (store.userData.imageUrl) {
  //         setUserImageUrl(store.userData.imageUrl);
  //       }

  //       if (!store.userData.userColor) {
  //         updateUserColor(
  //           BASE_URL,
  //           localStorage.getItem('token'),
  //           store.userData.userId,
  //           getRandomBgColor(),
  //         );
  //       }
  //     }

      
  //   } 

  // }, [userId]);




  //// get group list after socketId obtained
  useEffect(() => {
    // if (userSocketId) {
    //   getGroupListHandler();
    // }

    if (userId && userSocketId && groupList.length === 0) {
      getGroupListHandler();
    }
    // if (userId && userSocketId && store.groupListData.length > 0) {
    //   setGroupList(store.groupListData);
    // }

  }, [userSocketId, userId])


  //// join group 
  useEffect(() => {
    if (isGroupMember && showGroupTalkText && selectedGroupData
      && selectedGroupData._id) {
      joinGroupHandler(selectedGroupData._id);
    }
  }, [isGroupMember, showGroupTalkText, selectedGroupData]);

 
  //// initialize selected group data
  useEffect(() => {
    if (!roomIdParam) {
      setShowGroupTalkText(false);
      leaveGroupHandler();

      resetSelectedGroupStoreData();
      // socketDisconnectHandler();
    }

    //// reset selected group data when page leave
    return () => {
      resetSelectedGroupStoreData();
    }
  },[roomIdParam]);


  const resetSelectedGroupStoreData = () => {
    
    //// update roomInUsersData when member user left group 
    if (socketState && userData && isGroupMember && groupRoomInUsersData && selectedGroupData &&
        groupRoomInUsersData.groupRoomId === selectedGroupData._id
    ) {
        console.log('before getGroupRoomInUsersHandler in GropTalk')
        getGroupRoomInUsersHandler(
          socketState,
          userData.userId,
          selectedGroupData._id,
        );
    }

    //// reset selected group data
    dispatch('SET_SELECTEDGROUPDATA', null);
    dispatch('SET_GROUPROOMINUSERSDATA', null);
    dispatch('SET_ISGROUPMEMBER', false);
    dispatch('CLEAR_NOTIFICATION');

    dispatch('SET_SELECTEDKURAFILEDATA', null);
  };

  const leaveGroupHandler = () => {
    // socketState.emit('disconnect', {});
    if (socketState) {

      if (isAuth) {
        socketState.disconnect();
        socketState.connect();
      }
      initUseState();

      props.history.replace('/group-talk-page');
      
      dispatch('SET_GROUPMEMBER_IMAGEURLS', []);
    }
  };

  const initUseState = () => {
    setUserSocket('');
    setUserList([]);
    setCallFrom('');
    setCallingTo('');
    setIsCalling(false);
    setTextInput('');
    setTextInputList([]);
    setUserImageUrl('');
    setUserListObj([]);
    setShowTextTalk(false);
    setIsTextTalkDiv(false);
    setTryingToCallUser('');
    setTalkStartAt('');
    setCallReject(false);
    setNoUserMessage('');
    setUserTextTalkList([]);
    setShowUserTextTalkList(true);
    setShowNoconnectTextTalk(false);
    setNoconnectDestUserId('');
    setCallGet(false);
    setSuggestList([]);
    setNoconnectMessageNotify('');
  
    setIsLoading(false);
    setShowGroupCreation(false);
    setCreateGroupReslut('');
    setIsCreateGroup(false);
    setShowGroupTalkText(false);
    setDeleteMemberResult('');
    setDeleteGroupResult('');
  
    // setGroupTextInput('');
    setGroupTalkInputList([]);
    setGroupTalkId('');
    setGroupInfo('');
  
    setShowGroupTextInputElement(true);
    setIsTextPosting(false);

    setShowAuthModal(false);

    setGroupUserInfo();
    setEditFavoriteGroupsResult('');

    setGroupTextReactions([]);

  };




  const textInputHandlerEmoji = (input, value) => {
    // setTextInput(value);
    // setGroupTextInput(value);
    dispatch('SET_GROUPTEXTINPUT', value);
    // console.log(commentInput);
  }
  const getInputHandler = (input) => {
    // setTextInput(input);
    // setGroupTextInput(input);
    dispatch('SET_GROUPTEXTINPUT', input);
  }




  const createGroupHandler = (userId, groupName, keywords, isPrivate) => {
    if (isAuth) {
      // const userObj = userListObj.find(user => {
      //   return user.userId === userId;
      // });
  
      // console.log(userId, userObj, userListObj);
  
      // if (userObj) {
      if (userSocketId && userId) {
        setIsLoading(true);
        setCreateGroupReslut('');
  
        socketState.emit('create-group', {
          userId: userId,
          groupName: groupName,
          user: {
            socketId: userSocketId,
            userId: userId,
            userName: userName
          },
          language: navigator.languages[0],
          keywords: keywords,
          token: lsToken,
          isPrivate: isPrivate,
        });
      }
    } else {
      setShowAuthModal(true);
    }

  }

  const upgradeGroupHandler = (
    userId,
    previousGroupName,
    newGroupName,
    newDescription,
    newKeywords,
    groupRoomId,
  ) => {
    if (isAuth) {

      // const userObj = userListObj.find(user => {
      //   return user.userId === userId;
      // });
  
      // console.log(userId, userObj, userListObj);
  
      // if (userObj) {
      if (userSocketId && userId) {
        setIsLoading(true);
        setCreateGroupReslut('');
        // console.log(previousGroupName, newGroupName);
  
        socketState.emit('upgrade-group', {
          userId: userId,
          previousGroupName: previousGroupName,
          newGroupName: newGroupName,
          newDescription: newDescription,
          newKeywords: newKeywords,
          groupRoomId: groupRoomId,
          user: {
            socketId: userSocketId,
            userId: userId,
            userName: userName
          },
          token: lsToken,
        });
      }

    }
    else {
      setShowAuthModal(true);
    }

  };


  const joinGroupHandler = (groupRoomId) => {
    if (isAuth) {
        socketState.emit('join-group', {
          groupRoomId: groupRoomId,
          user: {
            socketId: userSocketId,
            userId: userId,
            userName: userName
          },
          token: lsToken,
        });
  
      // // if (userObj) {
      // if (userSocketId && userId) {
      //   setIsLoading(true);
  
      //   socketState.emit('join-group', {
      //     groupRoomId: groupRoomId,
      //     user: {
      //       socketId: userSocketId,
      //       userId: userId,
      //       userName: userName
      //     },
      //     token: lsToken,
      //   });
      // }
    }
    else {
      setShowAuthModal(true);
    }

  };


  const getGroupListHandler = () => {
    if (userSocketId && userId) {
      setIsLoading(true);

      socketState.emit('get-group-list', {
        user: {
          socketId: userSocketId,
          userId: userId,
          userName: userName,
        },
        token: lsToken,
      })
    }
  };

  const getGroupInfoHandler = (groupRoomId) => {  
    if (userSocketId && userId) {
      setIsLoading(true);
      
      socketState.emit('get-group-info', {
        groupRoomId: groupRoomId,
        user: {
          socketId: userSocketId,
          userId: userId,
          userName: userName,

          language: navigator.languages[0],
          geolocation: JSON.parse(localStorage.getItem('userLocation')),
          userAgent: navigator.userAgent,
        },
        token: lsToken,
      })
    }
  };

  const groupTextPostHandler = (
    text, 
    groupRoomId, 
    filePaths, 
    fileSizes,
    kuraFileInfo,
    replyInfo,
  ) => {
    const lsNameDataList = localStorage.getItem('lsNameDataList');

    let fromUserNameData;
    if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
      fromUserNameData = JSON.parse(lsNameDataList).find(ele => {
        return ele.userId === userId;
      });
    }
    
    if (isAuth) {
      if (userSocketId && userId) {
      
        socketState.emit('group-text-send', {
          from: userSocketId,
          fromUserId: userId,
          // to: '',
          // toUserId: toUserId,
          text: text,
          fromName: userName,
          groupRoomId: groupRoomId,
          sendAt: Date.now(),
          language: navigator.languages[0],
          geolocation: JSON.parse(localStorage.getItem('userLocation')),
          token: lsToken,

          fileUrls: filePaths ? filePaths : [],
          filePaths: filePaths ? filePaths : [],
    
          fileSizes: fileSizes ? fileSizes : [],

          fromUserNameData: fromUserNameData,
          kuraFileInfo: kuraFileInfo,
          replyInfo: replyInfo,
        });
  
        // deleteDraftInput('group', groupTalkId);
        deleteDraftInput('group', groupRoomId);
        // setIsTextPosting(true);
        // setGroupTextInput('');
        dispatch('SET_GROUPTEXTINPUT', '');

      }
    }
    else {
      setShowAuthModal(true);
    }
   
  };


  const groupTextDeleteHandler = (groupRoomId, groupTalkTextId, fromUserId) => {
    if (isAuth) {

      if (userSocketId && userId) {
      
        socketState.emit('group-text-delete', {
          user: {
            socketId: userSocketId,
            userId: userId,
            userName: userName
          },
          token: lsToken,
          groupRoomId: groupRoomId,
          groupTalkTextId: groupTalkTextId,
          fromUserId: fromUserId,
        });

        setIsLoading(true);
  
      }
    }
    else {
      setShowAuthModal(true);
    }
   
  };


  const deleteGroupHandler = (groupRoomId, userId) => {
    if (isAuth) {
      if (userSocketId && userId) {
        setIsLoading(true);
        setDeleteGroupResult('');
  
        socketState.emit('delete-group', {
          groupRoomId: groupRoomId,
          user: {
            socketId: userSocketId,
            userId: userId,
            userName: userName
          },
          token: lsToken,
        });
      }
    }
    else {
      setShowAuthModal(true);
    }

  };

  const deleteGroupMemberHandler = (groupRoomId, deleteUserId) => {
    if (isAuth) {

      if (userSocketId && userId) {
        setIsLoading(true);
        setDeleteMemberResult('');
  
        socketState.emit('delete-group-member', {
          groupRoomId: groupRoomId,
          deleteUserId: deleteUserId,
          user: {
            socketId: userSocketId,
            userId: userId,
            userName: userName
          },
          token: lsToken,
        });
      }
    }
    else {
      setShowAuthModal(true);
    }
    
  };


  const getGroupUserHandler = (userId) => {
    if (isAuth) {

      if (userSocketId && userId) {
        setIsLoading(true);
        // setDeleteMemberResult('');
  
        socketState.emit('get-group-user', {
          userId: userId,
          token: lsToken,
        });
      }
    }
  };

  const editFavoriteGroupsHandler = (userId, favoriteGroups) => {
    if (isAuth) {
      if (userSocketId && userId) {
        setIsLoading(true);
        setEditFavoriteGroupsResult('');
  
        socketState.emit('edit-favorite-groups', {
          userId: userId,
          favoriteGroups: favoriteGroups,
          // user: {
          //   socketId: userSocketId,
          //   userId: userId,
          //   userName: userName
          // },
          token: lsToken,
        });
      }
    }
  };


  const createGroupTextReactionHandler = (userId, groupRoomId, groupTalkTextId, type) => {
    if (socketState) {
      // setIsReactionPosting(true);
      setIsLoading(true);

      socketState.emit('create-group-text-reaction', {
        userId: userId,
        groupRoomId: groupRoomId,
        groupTalkTextId: groupTalkTextId,
        type: type,
        token: lsToken,
      });
    }  

  };





  // const groupTextInputHandler = (event) => {
  //   setGroupTextInput(event.target.value);
  // };

  const hideGroupCreationHandler = () => {
    window.scrollTo(0, 0);

    setShowGroupCreation(false);
    // setIsUpdateGroup(false);
  }

  // const showGroupCreationConfirmHandler = () => {
  //   setShowGroupCreationConfirm(!showGroupCreationConfirm);
  // }

  const createGroupStartHandler = () => {

    setShowGroupCreation(true);
    setIsCreateGroup(true);

    setCreateGroupReslut('');
  };

  const updateGroupStartHandler = (groupInfo) => {
    // console.log(groupInfo);

    setShowGroupCreation(true);
    setIsCreateGroup(false);

    setSelectedGroupForEdit(groupInfo);

    setCreateGroupReslut('');
  };

  // const getIsMemberHandler = (memberState) => {
  //   // setIsMember(memberState);
  //   // dispatch('SET_ISMEMBER', memberState);
  // };

  const showGroupTalkTextHandler = (groupRoomId, shareGroupId, shareFileType) => {
      if (!showGroupTalkText) {
        if (shareGroupId && shareFileType) {
          props.history.push(`/group-talk-page/?groupRoomId=${groupRoomId}&shareGroupId=${shareGroupId}&shareFileType=${shareFileType}`);  
        } else {
          props.history.push(`/group-talk-page/?groupRoomId=${groupRoomId}`);
        }
        // props.history.push(`/group-talk-page/${groupRoomId}`);
  
        //// get group member info for nameDataList and memberList
        getUsersDataForGroupHander(groupRoomId);

      }
      else {
        props.history.push('/group-talk-page');
      }
  
      setShowGroupTalkText(!showGroupTalkText);
  };

  const getUsersDataForGroupHander = async (groupRoomId) => {
    try {
        //// get group member info for nameDataList and memberList
        const resData = await getUsersForGroup(
          SOCKET_GROUP_URL,
          localStorage.getItem('token'),
          groupRoomId,
        );
  
        console.log('resData', resData);
        
        if (resData.userNameDataList?.length > 0) {
          updateLsNameDataList(resData.userNameDataList);
        }
  
        // if (resData.groupInfo?.allMemberUserIds?.length > 0) {
        //   setGroupAllMemberList(resData.groupInfo.allMemberUserIds);
        // }
  
    } catch(err) {
      console.log(err);
    }
  }

  const showGroupTextInputElementHandler = () => {
    setShowGroupTextInputElement(!showGroupTextInputElement);
  };





  let groupControlBody;

  groupControlBody = (
    <GroupTalkControl 
      userId={userId}
      showGroupTalkText={showGroupTalkText}
      showGroupCreation={showGroupCreation}
      isCreateGroup={isCreateGroup}
      createGroupHandler={createGroupHandler}
      createGroupReslut={createGroupReslut}
      hideGroupCreationHandler={hideGroupCreationHandler}
      getGroupListHandler={getGroupListHandler}
      selectedGroupForEdit={selectedGroupForEdit}
      upgradeGroupHandler={upgradeGroupHandler}
      groupUserInfo={groupUserInfo}
      showGroupTalkTextHandler={showGroupTalkTextHandler}
      getGroupInfoHandler={getGroupInfoHandler}
      editFavoriteGroupsHandler={editFavoriteGroupsHandler}
      editFavoriteGroupsResult={editFavoriteGroupsResult}
      setShowAuthModal={setShowAuthModal}
      createGroupStartHandler={createGroupStartHandler}
      updateGroupStartHandler={updateGroupStartHandler}
      deleteGroupHandler={deleteGroupHandler}
      deleteGroupResult={deleteGroupResult}
      getGroupUserHandler={getGroupUserHandler}
      isLoading={isLoading}
    />
  );

  let groupTextBody;

  groupTextBody = (
    <GroupTalkText 
      userId={userId}
      showGroupTalkText={showGroupTalkText}
      joinGroupHandler={joinGroupHandler}
      deleteGroupMemberHandler={deleteGroupMemberHandler}
      deleteMemberResult={deleteMemberResult}
      setShowAuthModal={setShowAuthModal}
      groupUserInfo={groupUserInfo}
      editFavoriteGroupsHandler={editFavoriteGroupsHandler}
      editFavoriteGroupsResult={editFavoriteGroupsResult}
      showGroupTextInputElement={showGroupTextInputElement}
      groupTextReactions={groupTextReactions}
      createGroupTextReactionHandler={createGroupTextReactionHandler}
      getGroupInfoHandler={getGroupInfoHandler}
      groupTextDeleteHandler={groupTextDeleteHandler}
      getInputHandler={getInputHandler}
      textInputHandlerEmoji={textInputHandlerEmoji}
      groupTextInput={groupTextInput}
      groupTextPostHandler={groupTextPostHandler}
      showGroupTextInputElementHandler={showGroupTextInputElementHandler}
      isTextPosting={isTextPosting}
      showGroupTalkTextHandler={showGroupTalkTextHandler}
      leaveGroupHandler={leaveGroupHandler}
      isLoading={isLoading}
    />
  );




  
  return (
    <Fragment>
      <div className="groupTalk__appContainer">
        <div>

        {!showGroupTalkText && !roomIdParam && store.windowValues && (store.windowValues.width < 768) && (
          <AdElementDisplay
            adType='300x65' 
            adPlaceId='grouppage-top' 
          />
        )}
        {store.windowValues && (store.windowValues.width >= 768) && (
        <AdElementDisplay 
            adType='300x300'
            adPlaceId='grouppage-right' 
          />
        )}

      

        {showAuthModal && 
          <GroupTalkAuthModal 
            setShowAuthModal={setShowAuthModal}
          />
        }

          {isLoading &&
            <div className="groupTalk__loader">
              <Loader />
            </div>
          }

          <div>
            <div className="textTalk_NoconnectMessage">
              {noconnectMessageNotify}
            </div>

            <div className="groupTalk__ConnectButton">
              {noUserMessage}
              {/* {connectButton} */}
            </div>

            {groupControlBody}

            {groupTextBody}
          </div>

        </div>
      </div>

      <GroupTalkSocket 
        setIsLoading={setIsLoading}
        userId={userId}
        userName={userName}
        userImageUrl={userImageUrl}
        userListObj={userListObj}
        setUserListObj={setUserListObj}
        userSocketId={userSocketId}
        setNoconnectMessageNotify={setNoconnectMessageNotify}
        setCreateGroupReslut={setCreateGroupReslut}
        setGroupTalkInputList={setGroupTalkInputList}
        groupInfo={groupInfo}
        groupTalkId={groupTalkId}
        setGroupInfo={setGroupInfo}
        setGroupTalkId={setGroupTalkId}
        setDeleteGroupResult={setDeleteGroupResult}
        setDeleteMemberResult={setDeleteMemberResult}
        setIsTextPosting={setIsTextPosting}
        // setGroupTextInput={setGroupTextInput}
        setGroupUserInfo={setGroupUserInfo}
        setEditFavoriteGroupsResult={setEditFavoriteGroupsResult}
        setGroupTextReactions={setGroupTextReactions}
      />

      {/* {isAuth && (
        <GroupUserUpdate 
          userId={userId}
          setNoUserMessage={setNoUserMessage}
        />
      )} */}
      <GroupUserUpdate 
        userId={userId}
        setNoUserMessage={setNoUserMessage}
      />
    </Fragment>
  );
};

export default GroupTalk;